import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'progress-stages-bar',
  templateUrl: './progress-stages-bar.component.html',
  styleUrls: ['./progress-stages-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProgressStagesBarComponent implements OnChanges {
  @Input() stages: string[] = [];
  @Input() current = '';
  @Input() latest = '';
  @Input() markAllComplete = false;
  @Output() stageChange = new EventEmitter<{ stage: string; index: number }>();
  offset = 0;
  stageCount = 0;
  latestIndex = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.stages && changes.stages.currentValue) {
      this.stageCount = changes.stages.currentValue.length;
      const emptySpaces = this.stageCount - 1;
      this.offset = 3 / (emptySpaces * 2);
    }

    if (changes.latest && changes.latest.currentValue) {
      this.latestIndex = this.stages.indexOf(this.latest);
    }
  }

  padLeft(index: number, first: boolean, last: boolean) {
    if (first || last) return 'none';
    const pad = `${this.offset.toFixed(8)}rem`;
    return index + 1 <= this.stageCount / 2 ? `-${pad}` : pad;
  }

  changeStage(index: number, stage: string) {
    if (index <= this.latestIndex) this.stageChange.emit({ stage, index });
  }

  get progress() {
    //Marking the progress bar as 100% when all the steps are completed and moved to success page.
    if (this.markAllComplete) return 100;

    const num = (this.latestIndex / (this.stageCount - 1)) * 100;
    return num.toFixed(4);
  }
}
